import AcUnitIcon from '@mui/icons-material/AcUnit';
import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

const RootDiv = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 8px',
  backgroundColor: '#2196F31A',
  height: '100%',
  minHeight: '24px',
});

const ImgDiv = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: '#15365F0D',
  width: '24px',
  height: '24px',
  flexShrink: 0,
});

const InformationText = styled(Typography)({
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  color: '#0D3C61',
  flex: 1,
});

export const RefrigeratedInfo = () => {
  return (
    <RootDiv>
      <ImgDiv>
        <AcUnitIcon sx={{ fontSize: 16, color: '#0D3C61' }} />
      </ImgDiv>
      <InformationText>Producto refrigerado (2°C - 8°C)</InformationText>
    </RootDiv>
  );
};
